// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"5a24e275","455":"04f7ec80"}[chunkId] + ".chunk.js";
};